import type { PropType } from 'vue';
import type { TSpinnerProps } from './TSpinner.types';
import { get, merge } from 'es-toolkit/compat';
import { computed, defineComponent } from 'vue';
import { useTheme } from '../../composables/theme';
import { useStyles } from './TSpinner.styles';

const defaultProps = {
  size: 'auto',
  color: '#5C0087',
};

export const TSpinner = defineComponent({
  name: 'TSpinner',
  props: {
    size: String as PropType<TSpinnerProps['size']>,
    color: String as PropType<TSpinnerProps['color']>,
  },
  setup(_props, { attrs }) {
    const props = computed(() => merge({}, defaultProps, _props, attrs));

    const theme = useTheme();
    const color = computed(() => (get(theme.value.colors, props.value.color) as string)
      || props.value.color);

    const baseClass = useStyles({ color: color.value });
    const classes = computed(() => [
      baseClass.value,
      `${baseClass.value}--${props.value.size}`,
    ]);

    return () => <div class={classes.value} />;
  },
});
